import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { UserSearchDialogContext, UserSearchDialogInitialState } from ".";

export const UserSearchDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(UserSearchDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <UserSearchDialogContext.Provider value={context}>
      {children}
    </UserSearchDialogContext.Provider>
  );
};
